import { Grid, Paper, Typography } from '@material-ui/core';
import { type ICourseReport } from 'src/models';
import { type ReportType } from 'src/store/Courses/actions';
import useStyles from './CourseCard-styles';

interface Props {
	type: ReportType;
	courseReport: ICourseReport;
}

function CourseCard({ courseReport, type }: Props) {
	const classes = useStyles();

	return (
		<Grid item lg={4} md={6} xs={12}>
			<Paper className={classes.paper}>
				<Typography variant={'h3'}> {courseReport.name} </Typography>

				{type == 'all' && (
					<div>
						<Typography> Instituciones: </Typography>

						<Typography>
							{' '}
							{courseReport.registeredInstitutions}{' '}
						</Typography>
					</div>
				)}

				<div>
					<Typography> Usuarios registrados: </Typography>

					<Typography> {courseReport.registeredUsers} </Typography>
				</div>

				<div>
					<Typography> Usuarios activos: </Typography>

					<Typography> {courseReport.activeUsers} </Typography>
				</div>

				<div>
					<Typography> Aprobaron: </Typography>

					<Typography> {courseReport.passedUsers} </Typography>
				</div>
			</Paper>
		</Grid>
	);
}

export default CourseCard;
